<button
  class="btn btn-custom"
  [ngClass]="getBtnClass()"
  [routerLink]="route"
  tabindex="1"
  [disabled]="taskLoading"
  [style]="cssStyle"
>
  <i *ngIf="iconType" [ngClass]="iconType"></i>
  <span class="ml-2">{{ title | translate }}</span>
  <div *ngIf="taskLoading" class="spinner-border spinner-border-sm"></div>
</button>
